<div class="history-breadcrumb width-95 mb-8px">
  <div *ngFor="let breadcrumbParts of crumbData">
    <div *ngIf="breadcrumbParts != crumbData[crumbData.length-1]" class="font-16 mt-8px">
      <div class="flex-display">
        <div class="overflow-elipses">
          {{breadcrumbParts}}
        </div>
        <div><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Down"></div>
      </div>
    </div>
  </div>
</div>
